/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown> }} Notifications_Task_Completed_Creator_BodyInputs */

const en_notifications_task_completed_creator_body = /** @type {(inputs: Notifications_Task_Completed_Creator_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A task you created on case ${i?.caseNumber} was completed.`)
};

const pt_br2_notifications_task_completed_creator_body = /** @type {(inputs: Notifications_Task_Completed_Creator_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uma atividade que você criou no caso ${i?.caseNumber} foi concluída.`)
};

/**
* | output |
* | --- |
* | "A task you created on case {caseNumber} was completed." |
*
* @param {Notifications_Task_Completed_Creator_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_completed_creator_body = /** @type {((inputs: Notifications_Task_Completed_Creator_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Completed_Creator_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_completed_creator_body(inputs)
	return pt_br2_notifications_task_completed_creator_body(inputs)
});